<script setup lang="ts">
import ProjectSidebarToggle from '@/modules/Projects/ProjectSidebarToggle.vue'
import { useSidebar } from '@/sharedComponents/useSidebar'

const { isOpen: isMainSidebarOpen } = useSidebar()
</script>

<template>
  <div class="h-11 p-2">
    <div class="flex flex-row items-center justify-start">
      <!-- the max-w- class here supporting Workspaces/Crumbs/CrumbItem.vue's overflow max behavior -->
      <!-- we probably need a cleaner solution for this -->
      <nav
        aria-label="crumbs"
        class="flex basis-1/2 flex-row items-center justify-start transition duration-300 ease-in-out-quint"
        :class="!!$slots.default ? 'max-w-[calc(50%-160px)]' : 'max-w-[90%]'"
      >
        <Transition
          enter-active-class="transition-all duration-300 ease-in-out-quint"
          enter-from-class="opacity-0 w-0"
          enter-to-class="opacity-100 w-12"
          leave-active-class="transition-all duration-300 ease-in-out-quint"
          leave-from-class="opacity-100 w-12"
          leave-to-class="opacity-0 w-0"
        >
          <div
            v-if="!isMainSidebarOpen"
            class="flex flex-row items-center"
          >
            <ProjectSidebarToggle />
            <div class="mx-2 h-5 w-0.5 rounded border border-border-subtle" />
          </div>
        </Transition>
        <slot name="crumbs" />
      </nav>
      <div class="flex w-[320px] items-center justify-center">
        <slot />
      </div>
      <div class="flex max-w-[calc(50%-160px)] basis-1/2 justify-end gap-2">
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>
